import React, { Component } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'

import QueryBuilderField from './QueryBuilderField'
import LoadingDefault from '../../../Elements/Loading/LoadingDefault'
import QueryBuilderLink from './QueryBuilderLink'

class QueryBuilderCombinator extends Component {
    constructor(props) {
        super(props)

        this.state = {
            seldata: null,
            sellink: null,
            loadingDataFieldItems: false,
            loadingLinkFields: false,
            dataFields: [],
            linkFields: [],
        }

        this.addCombinator = this.addCombinator.bind(this)
        this.addDataField = this.addDataField.bind(this)
        this.addLinkField = this.addLinkField.bind(this)
        this.onChangeCombinator = this.onChangeCombinator.bind(this)
        this.onChangeField = this.onChangeField.bind(this)
        this.onChangeLink = this.onChangeLink.bind(this)
        this.fetchDataFields = this.fetchDataFields.bind(this)
        this.fetchLinkFields = this.fetchLinkFields.bind(this)
        this.onDeleteCombinator = this.onDeleteCombinator.bind(this)
        this.onDeleteLink = this.onDeleteLink.bind(this)
        this.onDeleteField = this.onDeleteField.bind(this)
    }

    initializeCombinator = (combinator) => {
        const { kedo } = this.props
        // Make a clone
        const clone = { ...combinator }

        // Ensure uuid
        if (!clone.uuid) clone.uuid = kedo.utils().uuidv4()

        // Default combine
        if (!clone.combine) clone.combine = 'AND'

        // Initialize fields
        clone.fields = (clone.fields || []).map((f) => ({
            ...f,
            uuid: f.uuid || kedo.utils().uuidv4(),
        }))

        // Initialize links
        clone.links = (clone.links || []).map((l) => ({
            ...l,
            uuid: l.uuid || kedo.utils().uuidv4(),
        }))

        // Recursive initialization for nested combinators
        clone.combinators = (clone.combinators || []).map((c) =>
            this.initializeCombinator(c)
        )

        return clone
    }

    fetchDataFields(ddId) {
        const { kedo } = this.props
        this.setState({ loadingDataFieldItems: true })
        kedo.api()
            .getCached(kedo.api().getDefDossierDefFieldEndpoint(), {
                params: { defDossier: ddId, limit: 500 },
            })
            .then((response) => {
                const systemFields = [
                    {
                        id: 'created_at',
                        name: 'created_at',
                        def_field: { type: 'systemdate' },
                    },
                    {
                        id: 'modified_at',
                        name: 'modified_at',
                        def_field: { type: 'systemdate' },
                    },
                    {
                        id: 'created_by',
                        name: 'created_by',
                        def_field: { type: 'systemuser' },
                    },
                    {
                        id: 'modified_by',
                        name: 'modified_by',
                        def_field: { type: 'systemuser' },
                    },
                ].map((f) => ({ ...f, uuid: kedo.utils().uuidv4() }))

                const fieldsWithUUID = response.data.results.map((f) => ({
                    ...f,
                    uuid: f.uuid || kedo.utils().uuidv4(),
                }))

                this.setState({
                    dataFields: [...fieldsWithUUID, ...systemFields],
                    loadingDataFieldItems: false,
                })
            })
    }

    fetchLinkFields(ddId) {
        const { kedo } = this.props
        this.setState({ loadingLinkFields: true })
        kedo.api()
            .get(kedo.api().getDefDossierLinkEndpoint(), {
                params: {
                    defDossier: ddId,
                    environment: kedo.env().getEnvironment().id,
                    limit: 500,
                },
            })
            .then((res) => {
                this.setState({
                    linkFields: res.data.results.map((l) => ({
                        ...l,
                        uuid: l.uuid || kedo.utils().uuidv4(),
                    })),
                    loadingLinkFields: false,
                })
            })
    }

    fetchFields() {
        //First node
        if (this.props.defdossier) {
            this.fetchDataFields(this.props.defdossier)
            this.fetchLinkFields(this.props.defdossier)
        } else if (this.props.defdossierlink) {
            //From link
            let ddlUrl = this.props.kedo.api().getDefDossierLinkEndpoint()
            this.props.kedo
                .api()
                .get(ddlUrl + '/' + this.props.defdossierlink)
                .then((response) => {
                    this.fetchDataFields(response.data.child_def_dossier_id)
                    this.fetchLinkFields(response.data.child_def_dossier_id)
                })
        }
    }

    componentDidMount() {
        const { field } = this.props
        if (field) {
            const initialized = this.initializeCombinator(field)
            this.props.onChange(this.props.index, initialized)
        }
        this.fetchFields()
    }

    onChangeField(index, field) {
        const updatedFields = [...this.props.field.fields]
        updatedFields[index] = field
        this.props.onChange(this.props.index, {
            ...this.props.field,
            fields: updatedFields,
        })
    }

    onChangeLink(index, link) {
        const updatedLinks = [...this.props.field.links]
        updatedLinks[index] = link
        this.props.onChange(this.props.index, {
            ...this.props.field,
            links: updatedLinks,
        })
    }

    onChangeCombinator(index, combinator) {
        const updatedCombinators = [...this.props.field.combinators]
        updatedCombinators[index] = combinator
        this.props.onChange(this.props.index, {
            ...this.props.field,
            combinators: updatedCombinators,
        })
    }

    addDataField() {
        if (!this.state.seldata) return
        const { kedo } = this.props
        const newField = (() => {
            if (['created_at', 'modified_at'].includes(this.state.seldata)) {
                return {
                    id: this.state.seldata,
                    name: this.state.seldata,
                    def_field: { type: 'systemdate' },
                    uuid: kedo.utils().uuidv4(),
                }
            }
            if (['created_by', 'modified_by'].includes(this.state.seldata)) {
                return {
                    id: this.state.seldata,
                    name: this.state.seldata,
                    def_field: { type: 'systemuser' },
                    uuid: kedo.utils().uuidv4(),
                }
            }
            return {
                id: parseInt(this.state.seldata),
                uuid: kedo.utils().uuidv4(),
            }
        })()

        this.props.onChange(this.props.index, {
            ...this.props.field,
            fields: [...this.props.field.fields, newField],
        })
    }

    addLinkField() {
        if (!this.state.sellink) return
        const { kedo } = this.props
        const newLink = {
            id: parseInt(this.state.sellink),
            uuid: kedo.utils().uuidv4(),
        }

        this.props.onChange(this.props.index, {
            ...this.props.field,
            links: [...this.props.field.links, newLink],
        })
    }

    addCombinator() {
        const { kedo, ddObject, linkField } = this.props
        const newCombinator = {
            uuid: kedo.utils().uuidv4(),
            combine: 'AND',
            fields: [],
            links: [],
            combinators: [],
            id: ddObject?.id || linkField?.id || undefined,
        }

        this.props.onChange(this.props.index, {
            ...this.props.field,
            combinators: [...this.props.field.combinators, newCombinator],
        })
    }

    onDeleteField(uuid) {
        const updated = this.props.field.fields.filter((f) => f.uuid !== uuid)
        this.props.onChange(this.props.index, {
            ...this.props.field,
            fields: updated,
        })
    }

    onDeleteLink(uuid) {
        const updated = this.props.field.links.filter((l) => l.uuid !== uuid)
        this.props.onChange(this.props.index, {
            ...this.props.field,
            links: updated,
        })
    }

    onDeleteCombinator(uuid) {
        const updated = this.props.field.combinators.filter(
            (c) => c.uuid !== uuid
        )
        this.props.onChange(this.props.index, {
            ...this.props.field,
            combinators: updated,
        })
    }

    render() {
        const {
            kedo,
            field,
            index,
            ddObject,
            linkField,
            defdossier,
            defdossierlink,
        } = this.props
        const fieldTypes = [
            'text',
            'textarea',
            'autoIncrement',
            'calc',
            'email',
            'url',
            'user',
            'list',
            'date',
            /* this is a virtual date field, used for created_at & modified_at */
            'systemdate',
            'systemuser',
            'amount',
        ]

        if (this.state.loading) {
            return <LoadingDefault />
        }

        const transparency = 0.14
        const backgrounds = [
            `rgba(179, 186, 197, ${transparency})`,
            `rgba(255, 235, 230, ${transparency})`,
            `rgba(255, 250, 230, ${transparency})`,
            `rgba(227, 252, 239, ${transparency})`,
            `rgba(222, 235, 255, ${transparency})`,
            `rgba(230, 252, 255, ${transparency})`,
            `rgba(179, 186, 197, ${transparency})`,
            `rgba(255, 235, 230, ${transparency})`,
            `rgba(255, 250, 230, ${transparency})`,
            `rgba(227, 252, 239, ${transparency})`,
            `rgba(222, 235, 255, ${transparency})`,
            `rgba(230, 252, 255, ${transparency})`,
        ]

        const combinators = field.combinators || []
        const fields = field.fields || []
        const links = field.links || []
        const combine = field.combine || 'AND'
        const level = Math.min(this.props.level || 0, backgrounds.length - 1)

        return (
            <div
                className={`card mb-3 ${
                    index % 2 === 0 ? 'border-primary' : 'border-secondary'
                }`}
                style={{ backgroundColor: backgrounds[level] }}
            >
                <div className="card-header text-white bg-secondary">
                    Combinator {ddObject?.name_plural || ''}{' '}
                    {linkField?.name || ''}
                    {this.state.loadingDataFieldItems ||
                    this.state.loadingLinkFields ? (
                        <LoadingDefault as={'span'} />
                    ) : null}
                    <div className="float-right input-group col-md-2">
                        <Form.Control
                            size={'sm'}
                            value={field.combine}
                            onChange={(e) =>
                                this.props.onChange(index, {
                                    ...field,
                                    combine: e.target.value,
                                })
                            }
                            name={'combine'}
                            as={'select'}
                        >
                            <option value={'AND'}>{kedo.t('AND')}</option>
                            <option value={'OR'}>{kedo.t('OR')}</option>
                        </Form.Control>
                        <div className="input-group-append">
                            <Button
                                className={'float-right'}
                                size={'sm'}
                                onClick={this.addCombinator}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                            <Button
                                variant={'secondary'}
                                className={'float-right'}
                                size={'sm'}
                                onClick={() => this.props.onDelete(field.uuid)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                {kedo.t('Data field')}{' '}
                                {this.state.loadingDataFieldItems ? (
                                    <LoadingDefault />
                                ) : null}
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            name={'seldata'}
                            onChange={(e) =>
                                this.setState({
                                    [e.target.name]: e.target.value,
                                })
                            }
                            as={'select'}
                        >
                            <option>{kedo.t('Choose an option')}</option>
                            {fieldTypes.map((fieldType) => (
                                <optgroup key={fieldType} label={fieldType}>
                                    {this.state.dataFields
                                        .filter(
                                            (dataField) =>
                                                dataField.def_field &&
                                                dataField.def_field.type ===
                                                    fieldType
                                        )
                                        .map((dataField) => (
                                            <option
                                                key={dataField.id}
                                                value={dataField.id}
                                            >
                                                {dataField.name}
                                            </option>
                                        ))}
                                </optgroup>
                            ))}
                        </Form.Control>
                        <InputGroup.Append>
                            <Button onClick={this.addDataField}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                {kedo.t('Link field')}{' '}
                                {this.state.loadingLinkFields ? (
                                    <LoadingDefault />
                                ) : null}
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                            name={'sellink'}
                            onChange={(e) =>
                                this.setState({
                                    [e.target.name]: e.target.value,
                                })
                            }
                            as={'select'}
                        >
                            <option>{kedo.t('Choose an option')}</option>
                            {this.state.linkFields.map((linkField) => (
                                <option key={linkField.id} value={linkField.id}>
                                    {linkField.name} - {linkField.id}
                                </option>
                            ))}
                        </Form.Control>
                        <InputGroup.Append>
                            <Button onClick={this.addLinkField}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>
                    <br />
                    {fields.map((field, fieldIndex) => (
                        <QueryBuilderField
                            key={field.uuid}
                            index={fieldIndex}
                            field={field}
                            onDelete={this.onDeleteField}
                            onChange={this.onChangeField}
                            kedo={this.props.kedo}
                            dataField={this.state.dataFields.find(
                                (dataItem) => dataItem.id === field.id
                            )}
                        />
                    ))}
                    {links.map((field, linkIndex) => (
                        <QueryBuilderLink
                            field={field}
                            level={this.props.level + 1}
                            key={field.uuid}
                            kedo={this.props.kedo}
                            defdossierlink={field.id}
                            onDelete={this.onDeleteLink}
                            index={linkIndex}
                            onChange={this.onChangeLink}
                            linkField={this.state.linkFields.find(
                                (linkItem) => linkItem.id === field.id
                            )}
                        />
                    ))}
                    {combinators.map((field, linkIndex) => (
                        <QueryBuilderCombinator
                            level={this.props.level + 1}
                            field={field}
                            key={field.uuid}
                            defdossier={this.props.defdossier}
                            kedo={this.props.kedo}
                            onDelete={this.onDeleteCombinator}
                            defdossierlink={field.id}
                            index={linkIndex}
                            onChange={this.onChangeCombinator}
                            linkField={this.state.linkFields.find(
                                (linkItem) => linkItem.id === field.id
                            )}
                        />
                    ))}
                </div>
            </div>
        )
    }
}

export default QueryBuilderCombinator
